
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/arcade-machines/search/[gameId]",
      function () {
        return require("private-next-pages/arcade-machines/search/[gameId]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/arcade-machines/search/[gameId]"])
      });
    }
  